<div *ngIf="show()"><ng-content></ng-content></div>